"use client";

import { useEffect, useState } from "react";

const CHEVRON = Array.from({ length: 9 }, (_, index) => {
  const row = Math.floor(index / 3);
  const column = index % 3;
  return (column + Math.abs(row - 1)) * 90;
});

const ORBIT_ORDER = [0, 1, 2, 5, 8, 7, 6, 3];
const ORBIT = Array.from({ length: 9 }, (_, index) => {
  const position = ORBIT_ORDER.indexOf(index);
  return position === -1 ? null : position * 110;
});

const PATTERNS = {
  Drive: { delays: CHEVRON, duration: 650, round: false },
  Dots: { delays: CHEVRON, duration: 650, round: true },
  Orbit: { delays: ORBIT, duration: 950, round: false },
};

function useElapsed() {
  const [tenths, setTenths] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => setTenths((value) => value + 1), 100);
    return () => window.clearInterval(timer);
  }, []);

  const total = tenths / 10;
  return total < 60 ? `${total.toFixed(1)}s` : `${Math.floor(total / 60)}m ${(total % 60).toFixed(1)}s`;
}

export default function LoadingState({ label = "Churning", variant = "Drive" }) {
  const elapsed = useElapsed();
  const pattern = PATTERNS[variant] || PATTERNS.Drive;

  return (
    <div className="loading-state" role="status" aria-label={`${label}, elapsed ${elapsed}`}>
      <span className="loading-state__grid" aria-hidden="true">
        {pattern.delays.map((delay, index) => (
          <span
            key={index}
            className={`loading-state__cell${pattern.round ? " loading-state__cell--round" : ""}`}
            style={{
              opacity: delay === null ? 0.07 : 0.15,
              animation: delay === null ? "none" : `loading-state-pixel-on ${pattern.duration}ms ease-in-out ${delay}ms infinite`,
            }}
          />
        ))}
      </span>
      <span className="loading-state__label">{label}</span>
      <span className="loading-state__elapsed" aria-hidden="true">{elapsed}</span>
    </div>
  );
}
